import type { ServiceAccountImpersonation as ServiceAccountImpersonationModel } from '@/adapters/catalogv1.g';

/**
 * Transform a backend ServiceAccountImpersonation model to a frontend
 * CatalogServiceAccountImpersonation type. The nested IAM condition is
 * flattened into discrete string fields so the flat column config can render
 * the expression, title, and description directly.
 * @param model - API ServiceAccountImpersonation response from catalog
 * @returns CatalogServiceAccountImpersonation - UI-friendly impersonation edge
 */
export function extractServiceAccountImpersonation(
  model: ServiceAccountImpersonationModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    principalRef: model.principal_ref ?? '',
    principalType: model.principal_type ?? '',
    serviceAccountRef: model.service_account_ref ?? '',
    roleRef: model.role_ref ?? '',
    kind: model.kind ?? '',
    condition: model.condition?.expression ?? '',
    conditionTitle: model.condition?.title ?? '',
    conditionDescription: model.condition?.description ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogServiceAccountImpersonation = ReturnType<
  typeof extractServiceAccountImpersonation
>;
